import "./App.css";

import { Link } from "react-router-dom";
import { useState } from "react";
import { WEB_APP_URL } from "./config";

function OurStory() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="bg-black text-gray-200">
      {/* Navbar */}
      <header className="bg-black bg-opacity-70 backdrop-blur-lg sticky top-0 w-full z-50 shadow-lg">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img
              src="/images/logo.png"
              alt="Fit-Match Logo"
              className="h-16 w-auto"
            />
            <Link to="/" className="text-2xl font-bold gradient-text">
              FIT-MATCH
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#how-it-works" className="nav-link font-medium">
              How It Works
            </Link>
            <Link to="/our-story" className="nav-link font-medium">
              Our Story
            </Link>
            <Link to="/professionals" className="nav-link font-medium">
              Pros
            </Link>
            <Link to="/training-providers" className="nav-link font-medium">
              Providers
            </Link>
            <Link to="/communities" className="nav-link font-medium">
              Communities
            </Link>
            <Link to="/facilities" className="nav-link font-medium">
              Facilities
            </Link>
            <a
              href={WEB_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link font-medium px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white"
            >
              Login
            </a>
          </div>
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-white focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-4 6h4"
                ></path>
              </svg>
            </button>
          </div>
        </nav>
        {/* Mobile Menu */}
        <div
          className={`${
            isMobileMenuOpen ? "block" : "hidden"
          } md:hidden bg-black bg-opacity-90 py-4`}
        >
          <Link
            to="/#how-it-works"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            How It Works
          </Link>
          <Link
            to="/our-story"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Our Story
          </Link>
          <Link
            to="/professionals"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Pros
          </Link>
          <Link
            to="/training-providers"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Providers
          </Link>
          <Link
            to="/communities"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Communities
          </Link>
          <Link
            to="/facilities"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Facilities
          </Link>
          <a
            href={WEB_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Login
          </a>
        </div>
      </header>

      <main className="pt-24">
        {/* Hero Section */}
        <section className="hero-bg-story py-12 md:py-16 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          <div className="container mx-auto px-6 relative z-10">
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight">
              Our <span className="gradient-text">Story</span>
            </h1>
            <p className="mt-4 text-lg md:text-xl max-w-2xl mx-auto">
              A shared vision to revolutionize the fitness industry.
            </p>
          </div>
        </section>

        {/* Story Content */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6 max-w-5xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold mb-4">
                  The Sports Scientist's Vision
                </h2>
                <p className="text-lg text-gray-400 leading-relaxed">
                  As a sports science student, I witnessed firsthand the
                  challenges fitness professionals faced. Talented trainers and
                  physiotherapists often struggled to find clients, relying on
                  word-of-mouth or expensive, commission-based platforms. The
                  industry needed a better way to connect with clients directly,
                  without the barriers of booking fees and middlemen.
                </p>
              </div>
              <div className="flex justify-center">
                <img
                  src="/images/Ethan.JPEG"
                  alt="Ethan - Sports Scientist"
                  className="h-64 w-64 md:h-80 md:w-80 rounded-lg object-cover border-4 border-blue-fit-match shadow-xl"
                />
              </div>
            </div>

            <div className="my-16 md:my-24 h-1 bg-gray-800 rounded-full mx-auto max-w-2xl"></div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
              <div className="order-2 md:order-1 flex justify-center">
                <img
                  src="/images/Adam.JPEG"
                  alt="Adam - Software Engineer"
                  className="h-64 w-64 md:h-80 md:w-80 rounded-lg object-cover border-4 border-blue-fit-match shadow-xl"
                />
              </div>
              <div className="order-1 md:order-2">
                <h2 className="text-3xl font-bold mb-4">
                  The Software Engineer's Solution
                </h2>
                <p className="text-lg text-gray-400 leading-relaxed">
                  As a software engineer, I knew technology could be the bridge.
                  We could build an intuitive mobile application that would act
                  like a "dating app for fitness." This platform would allow
                  professionals to showcase their services and clients to easily
                  discover them on a map, all powered by clean, efficient code.
                  The goal was to eliminate the overhead and make direct
                  connections simple.
                </p>
              </div>
            </div>

            <div className="my-16 md:my-24 h-1 bg-gray-800 rounded-full mx-auto max-w-2xl"></div>

            <div className="text-center">
              <h2 className="text-3xl font-bold mb-4">Our Shared Passion</h2>
              <p className="text-lg text-gray-400 leading-relaxed max-w-4xl mx-auto">
                By combining our unique perspectives—the{" "}
                <strong>sports science</strong> knowledge of industry needs and
                the <strong>software engineering</strong> expertise to build a
                solution—we were able to create Fit-Match. Our mission is to
                empower both professionals and clients by providing a
                transparent, simple, and affordable platform. We believe that
                finding your perfect fitness match should be about connection,
                not commissions.
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 py-8 text-center text-gray-400">
        <p>&copy; 2024 Fit-Match. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default OurStory;
